import { AfterViewInit, ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import dayjs from 'dayjs';

@Component({
  selector: 'datepicker-cell-editor',
  template: `<kendo-datepicker #kendoDatePicker [format]="'MM/dd/yyyy'" style="width:100%" [min]="minDate"
                               [(ngModel)]="value" ></kendo-datepicker>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DatePickerComponent,
    FormsModule,
  ],
})

export class PxdAgDatePickerEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  public readonly container = viewChild<DatePickerComponent>('kendoDatePicker');

  ngAfterViewInit(): void {
    if (this.popup) {
      this.container().toggle();
    }
  }

  public value: Date;
  public minDate: Date = dayjs('01/01/2000').toDate();
  public popup: boolean = true;

  public agInit(params: any): void {
    if (params && params.minDate) {
      this.minDate = params.minDate;
    }
    if (params && params.value) {
      this.value = params.value;
    }
    if (params && params.popup !== undefined) {
      this.popup = params.popup;
    }
  }

  public getValue(): any {
    return this.value ? dayjs(this.value).toDate() : this.value;
  }
}